/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReportPackageAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2h18v3h-2V4H4v14h1v2H2z" />
        <path d="M9 14a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm4-2.83a3.001 3.001 0 1 0 3.941 2.236L13 15.763zm2 0v1.067l.914-.547a3.028 3.028 0 0 0-.914-.52z" />
        <path d="M6 6h16v16H6zm2 2v12h12V8z" />
      </g>
    </g>
  </Icon>
);
export { SvgReportPackageAlt as ReportPackageAlt };
